import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'app-loan-servicing-settings',
  templateUrl: './loan-servicing-settings.component.html',
  styleUrls: ['./loan-servicing-settings.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterModule, MatIconModule, MatListModule, MatSidenavModule],
})
export class LoanServicingSettingsComponent {}